<template>
  <div class="upload-content">
    <div>
      <p class="tag">{{ prompt }}</p>
      <el-upload
        ref="upload"
        class="avatar-uploader"
        action="https://up-z2.qiniup.com"
        :data="uploadData"
        :show-file-list="false"
        :on-success="handleSuccess"
        :before-upload="beforeUpload"
        :on-error="handleError"
        accept="image/jpeg, image/jpg, image/png"
        v-loading="loading"
        element-loading-text="拼命上传中..."
        element-loading-spinner="el-icon-loading"
        element-loading-background="rgba(0, 0, 0, 0.68)"
        :disabled="disabled"
        :drag="drag"
      >
        <div
          class="avatar"
          v-if="url"
          :style="{
            backgroundImage:`url(${url})`,
            width: width,
            height: height
          }"
        ></div>
        <div v-else>
          <template v-if="drag">
            <i class="el-icon-upload"></i>
            <div class="el-upload__text">
              将文件拖到此处，或
              <em>点击上传</em>
            </div>
          </template>
          <i v-else class="el-icon-plus avatar-uploader-icon"></i>
        </div>
      </el-upload>
    </div>
  </div>
</template>

<script>
import { getQiNiuYunToken } from '@/api/common';

export default {
  name: 'Upload',
  data() {
    return {
      loading: false,
      domain: '',
      uploadData: {
        token: '',
      },
    };
  },
  props: {
    url: {
      type: String,
      default: '',
    },
    drag: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    prompt: {
      type: String,
      default:
        '上传轮播图片：大小不超过2M，支持Jpeg、Jpg、Png格式，建议上传750*392尺寸。',
    },
    width: {
      type: String,
      default: '160px',
    },
    height: {
      type: String,
      default: '160px',
    },
  },
  mounted() {
    this.getQniuyunToken();
  },
  methods: {
    getQniuyunToken() {
      getQiNiuYunToken().then((res) => {
        if (res.success && res.data) {
          const { domain, token } = res.data;
          this.uploadData.token = token;
          this.domain = domain;
        } else {
          this.$message.error(res.message);
        }
      });
    },
    beforeUpload(file) {
      const isJPEG = file.type === 'image/jpeg';
      const isJPG = file.type === 'image/jpg';
      const isPNG = file.type === 'image/png';
      const isLt2M = file.size / 1024 / 1024 < 2;

      if (!(isJPG || isPNG || isJPEG)) {
        this.$message.error('上传头像图片只能是 Jpeg、JPG 或 PNG 格式！');
      }
      if (!isLt2M) {
        this.$message.error('上传头像图片大小不能超过 2MB!');
      }
      const isPass = (isJPG || isPNG || isJPEG) && isLt2M;

      if (isPass) {
        this.loading = true;
      }
      return isPass;
    },
    handleSuccess(res) {
      const completeUrl = `${this.domain}${res.key}`;
      this.$emit('successUpload', completeUrl);
      this.loading = false;
    },
    handleError(err) {
      this.loading = false;
      this.$message.error(`上传失败！错误：${err}`);
      this.getQniuyunToken();
    },
    clearFiles() {
      this.$refs.upload.clearFiles();
    },
  },
};
</script>

<style lang="stylus" scoped>
@import '~assets/css/mixins'
.upload-content
  flex-row()
  span
    margin-right 30px
  p
    margin-top 0
    margin-bottom 24px
  .avatar-uploader
    display inline-block
    >>>.el-upload
      border 1px dashed #d9d9d9
      border-radius 6px
      cursor pointer
      position relative
      overflow hidden
      &:hover
        border-color #409EFF
    .avatar-uploader-icon
      font-size 28px
      color #8c939d
      width 160px
      height 160px
      line-height 160px
      text-align center
    .avatar
      display block
      background-position center
      background-repeat no-repeat
      background-size cover
</style>
